import React from 'react';
import IntlTelInput from "intl-tel-input/react";
import "intl-tel-input/styles";
import { PhoneNumberInputContainer } from './style';
import InteractiveHint from 'components/InteractiveHint';

export type InputFieldContainerProps = {
  className?: string;
  placeholder?: string;
  label?: string;
  labelPosition?: 'left' | 'center';
  labelColor?: string;
  labelSize?: string;
  labelWeight?: string;
  borderColor?: string;
  inputHeight?: string;
  inputTextColor?: string;
  inputFontSize?: string;
  inputFontWeight?: string;
  inputBackgroundColor?: string;
  error?: boolean;
  errorMessage?: string;
  width?: string;
  marginLeft?: string;
  marginBottom?: string;
  isRequired?: boolean;
  initialValue?: string;
  disabled?: boolean;
  placeholderColor?: string;
  placeholderFontSize?: string;
  iconUrl?: string;
  iconHint?: Pick<React.ComponentProps<typeof InteractiveHint>, 'title' | 'content'>;
  onChangeNumber: (e: any) => void;
  setPhoneNumberValidity?: (e: any) => void;
  onBlur?: (e: any) => void;
};

const PhoneNumberInput: React.FC<InputFieldContainerProps> = ({
  className,
  placeholder,
  width,
  label,
  inputBackgroundColor,
  isRequired,
  onChangeNumber,
  setPhoneNumberValidity,
  onBlur,
  initialValue,
  disabled,
  iconUrl,
  iconHint,
  ...layout
}) => {

  return (
    <PhoneNumberInputContainer
      className={className}
      labelPosition={layout.labelPosition}
      labelColor={layout.labelColor}
      labelSize={layout.labelSize}
      labelWeight={layout.labelWeight}
      borderColor={layout.borderColor}
      inputHeight={layout.inputHeight}
      inputTextColor={layout.inputTextColor}
      inputFontSize={layout.inputFontSize}
      inputFontWeight={layout.inputFontWeight}
      placeholderColor = {layout.placeholderColor}
      placeholderFontSize = {layout.placeholderFontSize}
      inputBackgroundColor={inputBackgroundColor}
      error={layout.error}
      width={width}
      marginLeft={layout.marginLeft}
      marginBottom={layout.marginBottom}
      iconUrl={iconUrl}
    >
      {label?
        <label>
          {label}
          {isRequired? <span className="required"> *</span>: null}
        </label>
      : null
      }
      <div className="phoneInputWrapper">
      <IntlTelInput
        initialValue={initialValue || ''}
        
        initOptions={{ 
          initialCountry: 'ca',
          placeholderNumberType	: 'MOBILE',
          autoPlaceholder: 'off',
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.10/build/js/utils.js"
        }}
        inputProps={{
          placeholder: placeholder,
          onBlur: onBlur,
          disabled: disabled,
        
          onKeyDown: (e: any) => {
            if (e.ctrlKey || e.metaKey) {
              return;
            }
          
            const allowed =
              /[0-9+\-()\s]/.test(e.key) ||
              [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'Tab',
                'Home',
                'End'
              ].includes(e.key);
          
            if (!allowed) {
              e.preventDefault();
            }
          },
        
          onPaste: (e: any) => {
            e.preventDefault();
        
            const input = e.currentTarget as HTMLInputElement;
            const pasted = e.clipboardData.getData('text');
        
            let cleaned = pasted.replace(/[^\d+]/g, '');
        
            cleaned = cleaned.replace(/\+/g, '');
            if (pasted.trim().startsWith('+')) {
              cleaned = `+${cleaned}`;
            }
        
            const start = input.selectionStart ?? input.value.length;
            const end = input.selectionEnd ?? input.value.length;
        
            const newValue =
              input.value.slice(0, start) +
              cleaned +
              input.value.slice(end);
        
            input.value = newValue;
        
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }}
        onChangeNumber={onChangeNumber}
        onChangeValidity={setPhoneNumberValidity}
      />
      {iconUrl ? (
        iconHint ? (
          <span className="phoneInputIcon">
            <InteractiveHint {...iconHint}>
              <img src={iconUrl} alt={typeof iconHint.title === 'string' ? iconHint.title : ''} />
            </InteractiveHint>
          </span>
        ) : <img src={iconUrl} className="phoneInputIcon" alt="" aria-hidden="true" />
      ) : null}
      </div>
      {layout.error? <div className="warning">{layout.errorMessage?.length? layout.errorMessage: 'This field is required.'}</div>: null}
    </PhoneNumberInputContainer>
  );
};

export default PhoneNumberInput;
